<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      Components
      <i class="fa fa-fw fa-question-circle" v-tooltip data-placement="right" title="Pull components from supplier"></i>
    </div>
    <div class="panel-body">
      <div class="form-inline form-inline--better-spaced form-inline--one-liner--">
        <div class="form-group">
          <label title="This product ID refered to is from the Supplier">Product ID</label>
          <input class="form-control" type="text" v-model="supplierProductId" :disabled="loading" title="This product ID refered to is from the Supplier" />
        </div>
        <div class="form-group">
          <label>Supplier</label>
          <select class="form-control" v-model="supplierId" :disabled="loading">
            <option :value="null">Sellect Supplier</option>
            <option v-for="(opt, key) in supplierOptions" :key="key" :value="opt.value" v-html="opt.label"></option>
          </select>
        </div>
      </div>
      <div class="form-inline form-inline--better-spaced form-inline--one-liner--">
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="viewComponents" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-eye"></i> View Components</button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="pullComponents" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-check"></i> Pull Components</button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="clearForm" :disabled="(!formIsOk || loading) && !payload"><i class="fa fa-fw fa-times"></i> Clear</button>
        </div>
      </div>
      <div v-if="!!payload">
        <a href="#" @click.prevent="togglePayloadView">{{ showPayload ? 'Hide' : 'Show' }} Payload</a>
        <pre v-if="showPayload">{{ payload }}</pre>
      </div>
    </div><!-- .panel-body -->
  </div><!-- .panel -->
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ApiResponseMixin from '@/plugin/mixin/api-response'
import Tooltip from '@/plugin/directive/tooltip'

export default {
  name: 'pull-components-form-component',
  data() {
    return {
      supplierProductId: null,
      supplierId: null,
      showPayload: true
    }
  },
  computed: {
    ...mapState('dropship/seller/syncProduct', {
      supplierOptions: 'supplierOptions',
      payload: 'components'
    }),
    ...mapGetters('dropship/seller/syncProduct', {
      isRequestingServer: 'isRequestingServer'
    }),
    formIsOk() {
      return this.supplierProductId && this.supplierId
    },
    loading() {
      return this.isRequestingServer
    }
  },
  methods: {
    togglePayloadView() {
      this.showPayload = !this.showPayload
    },
    viewComponents() {
      this.showPayload = true
      this.$store.dispatch(
        'dropship/seller/syncProduct/viewSupplierProductComponents',
        {supplierProductId: this.supplierProductId, supplierId: this.supplierId}
      )
    },
    async pullComponents() {
      try {
        const response = await this.$store.dispatch(
          'dropship/seller/syncProduct/pullSupplierProductComponents',
          {supplierProductId: this.supplierProductId, supplierId: this.supplierId}
        )
        if (response) {
          this.$alertify.success('Supplier product components pulled')
        } else {
          this.$alertify.error('Supplier product components NOT pulled')
        }
      } catch (reason) {
        if (this.isResponseError(reason)) {
          this.raiseErrorMessage(reason)
        } else {
          this.$alertify.error('An error was raised while requesting to pull supplier product components.  Message: ' + reason)
        }
      }
    },
    clearForm() {
      this.supplierProductId = null
      this.supplierId = null
      this.showPayload = true
      this.$store.dispatch('dropship/seller/syncProduct/clearSupplierProductComponents')
    }
  },
  directives: {
    tooltip: Tooltip
  },
  mixins: [
    ApiResponseMixin
  ]
}
</script>
